export default __webpack_public_path__ + "static/media/Path3538.add6652b.svg";